import React from 'react';
import { Card, Row, Col } from 'antd';
import { Link } from 'react-router-dom';


import './setup_maintenance_card.css';



function UserMaintenanceCard(props) {

	return (
		<Col span={6} offset={props.offset}>
			<Link to={props.link}>
				<Card className="setup-maintenance-item-card">
					<Row>
						<Col span={24}>
							<img src={props.image} alt="icon" />
						</Col>
					</Row>
					<Row>
						<Col 
							span={24} 
							style={{ 
									marginTop:'10px', 
									fontWeight: "bold", 
									fontSize: '15px',
							}} 
							className={props.className}
						>
							<span>{props.label}</span>
						</Col>
					</Row>
				</Card>
			</Link>
		</Col>
	);
}

export default UserMaintenanceCard;


